import React from "react";
import styled from "@emotion/styled";

import chroma from "chroma-js";
import { Company as CompanyInterface } from "interfaces/data";
import { Link } from "react-router-dom";

const StyledLink = styled(Link)`
  display: block;
  margin-bottom: 10px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

const StyledInfo = styled.p`
  font-weight: 600;
  font-size: 12px;
  line-height: 110%;
  color: ${(props) => props.theme.colors["sk-gray"]};
  margin-bottom: 10px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

const StyledContainer = styled.div<{ roleOnBottom?: boolean }>`
  display: ${(props) => (props.roleOnBottom ? "block" : "flex")};
  background: white;
  border: 1px solid ${(props) => props.theme.colors["sk-light-gray"]};
  box-sizing: border-box;
  border-radius: 16px;
  padding: 20px;
`;

const StyledName = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 110%;
  margin-bottom: 5px;
`;

const StyledBadge = styled.div<{ roleOnBottom?: boolean }>`
  background: ${(props) => props.theme.colors["sk-light-gray"]};
  border-radius: 16px;
  padding: 10px;
  margin-left: auto;
  align-self: flex-start;
  font-weight: 800;
  font-size: 11px;
  line-height: 110%;
  color: ${(props) => String(chroma(props.theme.colors["sk-dark"]).alpha(0.4))};
  ${(props) =>
    props.roleOnBottom &&
    `
    display: inline-block;
    margin-top: 10px;
  `}
`;

export function Company({ company, currentContactId }: { company: CompanyInterface; currentContactId: string }) {
  const type = company?.contacts?.find((c) => c.id === currentContactId)?.type || "";
  return (
    <StyledLink to={`/companies/${company.id}`}>
      <StyledContainer roleOnBottom={false}>
        <div>
          <StyledName>{company.name}</StyledName>
          <StyledInfo>{company.legalEntity}</StyledInfo>
        </div>
        <StyledBadge roleOnBottom={false}>{type}</StyledBadge>
      </StyledContainer>
    </StyledLink>
  );
}
